import React from 'react';

function Testimonials() {
  return (
    <section className="section container" style={{ backgroundColor: 'var(--color-bg-primary)', padding: '80px 24px' }}>
      <h2 className="section-title">Famiglie felici</h2>
      <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '48px' }}>
        
        <div style={{ background: '#fff', padding: '32px', borderRadius: '16px', boxShadow: 'var(--shadow-sm)', maxWidth: '350px' }} className="animate-on-scroll">
          <div style={{ display: 'flex', color: '#FFD700', marginBottom: '16px' }}>★★★★★</div>
          <p style={{ fontStyle: 'italic', marginBottom: '24px', color: 'var(--color-text-light)' }}>
            "Adottare Kira è stata la scelta migliore della nostra vita. I volontari di Glad Dogs sono stati eccezionali nel guidarci passo dopo passo."
          </p>
          <h4>Marco & Silvia</h4>
        </div>

        <div style={{ background: '#fff', padding: '32px', borderRadius: '16px', boxShadow: 'var(--shadow-sm)', maxWidth: '350px' }} className="animate-on-scroll">
          <div style={{ display: 'flex', color: '#FFD700', marginBottom: '16px' }}>★★★★★</div>
          <p style={{ fontStyle: 'italic', marginBottom: '24px', color: 'var(--color-text-light)' }}>
            "Il processo di adozione è stato rapido ma attento. Ora Max ha una casa e noi abbiamo un amico fedele!"
          </p>
          <h4>Famiglia Rossi</h4>
        </div>

      </div>
    </section>
  );
}

export default Testimonials;
